module.exports = __webpack_public_path__ + "media/images/xxxioscor_logo-a5a98ca475a451a380bdbff4c0f8142b.png";